import I18n from 'I18n';
import TimeRange from 'MeetingsBase/models/TimeRange'; // durations in milliseconds

export var MINUTES_TO_MILLIS = 60 * 1000;
export var ONE_HOUR = 60 * MINUTES_TO_MILLIS;
export var ONE_DAY = 60 * 24 * MINUTES_TO_MILLIS; // Durations

export var ZERO_DURATION = I18n.moment.duration(0).asMinutes();

var getDurationAsMillis = function getDurationAsMillis(duration) {
  return I18n.moment.duration({
    minutes: duration
  }).asMilliseconds();
};

var getDurationAsMinutes = function getDurationAsMinutes(duration) {
  return I18n.moment.duration({
    minutes: duration
  }).asMinutes();
};

export var FIFTEEN_MINUTE_DURATION = getDurationAsMinutes(15);
export var THIRTY_MINUTE_DURATION = getDurationAsMinutes(30);
export var HOUR_DURATION = getDurationAsMinutes(60);
export var DAY_DURATION = I18n.moment.duration({
  hours: 24
}).asMinutes();
export var TEN_MINUTE_MILLIS = getDurationAsMillis(10);
export var FIFTEEN_MINUTE_MILLIS = getDurationAsMillis(15);
export var THIRTY_MINUTE_MILLIS = getDurationAsMillis(30);
export var FORTY_FIVE_MINUTE_MILLIS = getDurationAsMillis(45);
export var SIXTY_MINUTE_MILLIS = getDurationAsMillis(60);
export var ONE_HOUR_FIFTEEN_MINUTE_MILLIS = 4500000;
export var ONE_HOUR_THIRTY_MINUTE_MILLIS = 5400000;
export var ONE_HOUR_FORTY_FIVE_MINUTE_MILLIS = 6300000;
export var TWO_HOURS_MILLIS = 7200000;
export var DAY_TIME_RANGE = TimeRange.from({
  start: ZERO_DURATION,
  end: DAY_DURATION
}); // The value to store for weeksToAdvertise when using custom availability.
// (weeksToAdvertise requires an integer value)

export var CUSTOM_AVAILABILITY = 0;
export var TWO_WEEKS = 2;
export var MAX_CUSTOM_AVAILABILITY_WEEKS = 10;
export var AVAILABLE_DAYS = {
  SUNDAY: 'SUNDAY',
  MONDAY: 'MONDAY',
  TUESDAY: 'TUESDAY',
  WEDNESDAY: 'WEDNESDAY',
  THURSDAY: 'THURSDAY',
  FRIDAY: 'FRIDAY',
  SATURDAY: 'SATURDAY'
};
export var AVAILABILITY_OPTIONS = Object.assign({
  EVERY_DAY: 'EVERY_DAY',
  MON_FRI: 'MON_FRI',
  SAT_SUN: 'SAT_SUN'
}, AVAILABLE_DAYS);
export var WEEKDAYS_LIST = [AVAILABLE_DAYS.SUNDAY, AVAILABLE_DAYS.MONDAY, AVAILABLE_DAYS.TUESDAY, AVAILABLE_DAYS.WEDNESDAY, AVAILABLE_DAYS.THURSDAY, AVAILABLE_DAYS.FRIDAY, AVAILABLE_DAYS.SATURDAY];